module.exports = __webpack_public_path__ + "static/media/business-advertising-promote.22d5ac92.png";